import type { ScorecardCountType } from "../../../criterionConfig";
import { Field } from "../Layout/Field";

import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const COUNT_TYPES: { value: ScorecardCountType; label: string }[] = [
  { value: "chars", label: "Characters" },
  { value: "words", label: "Words" },
  { value: "sentences", label: "Sentences" },
  { value: "paragraphs", label: "Paragraphs" },
];

interface CountFieldsProps {
  countType: ScorecardCountType;
  onCountTypeChange: (type: ScorecardCountType) => void;
  minCount: string;
  onMinCountChange: (value: string) => void;
  maxCount: string;
  onMaxCountChange: (value: string) => void;
  hasInvalidBounds: boolean;
}

export const CountFields = ({
  countType,
  onCountTypeChange,
  minCount,
  onMinCountChange,
  maxCount,
  onMaxCountChange,
  hasInvalidBounds,
}: CountFieldsProps) => (
  <div className="space-y-3">
    <Field label="Count of">
      <Select
        value={countType}
        onValueChange={value => onCountTypeChange(value as ScorecardCountType)}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select a type..." />
        </SelectTrigger>
        <SelectContent>
          {COUNT_TYPES.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>

    <div className="grid grid-cols-2 gap-3">
      <Field label="Min count">
        <Input
          value={minCount}
          onChange={event => onMinCountChange(event.target.value)}
          inputMode="numeric"
          placeholder="Optional"
        />
      </Field>
      <Field label="Max count">
        <Input
          value={maxCount}
          onChange={event => onMaxCountChange(event.target.value)}
          inputMode="numeric"
          placeholder="Optional"
        />
      </Field>
    </div>
    {hasInvalidBounds ? (
      <p className="text-xs text-red-600">
        Set at least one bound. Values must be non-negative integers, and min cannot exceed max.
      </p>
    ) : (
      <p className="text-xs text-muted-foreground">
        Pass when the counted value stays within the configured bounds.
      </p>
    )}
  </div>
);
